<template>
  <div>
    {{ text_body }}
    <router-link class="link" :to="path">
      {{ text_link }}
    </router-link>
  </div>
</template>

<script>
  export default {
    props: {
      path: {
        required: true,
        type: Object
      },
      text_link: {
        type: String,
        required: true
      },
      text_body: {
        type: String,
        required: true
      }
    }
  };
</script>